import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './FormStyles';

function FormSection(props) {
    const classes = useStyles();
    const {
        title,
        subText,
        children,
        addSpacer = false,
        sectionContainerClassName,
        fieldsClassName,
        ...otherProps
    } = props;
    return (
        <div className={`${classes.ngpFormSectionContainer} ${sectionContainerClassName || ''}`} {...otherProps}>
            {title && <Typography variant="h6">{title}</Typography>}
            <div className={`${classes.ngpFormFields} ${fieldsClassName || ''}`}>
                {subText && <Typography gutterBottom>{subText}</Typography>}
                {addSpacer && <Box mt={3} />}
                {children}
            </div>
        </div>
    );
}

FormSection.defaultProps = {
    title: '',
};

FormSection.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default FormSection;
